import { Bot, ArrowUpRight } from "lucide-react";
import { AI_AGENT_URL } from "@/lib/constants";

const VARIANT_CLASS = {
  gold: "btn-gold",
  ghost: "btn-ghost",
  outline: "btn-outline-white",
};

/**
 * Primary CTA that launches the hosted Fireflies AI Strategist agent
 * in a new tab. Default variant: gold (primary). Pass variant="ghost"
 * for the dark/secondary surface treatment.
 */
export default function AIAgentCTA({
  variant = "gold",
  label = "Talk to our AI Strategist",
  testId = "ai-agent-cta",
  className = "",
  size = "default", // "default" | "sm"
}) {
  const base = VARIANT_CLASS[variant] || VARIANT_CLASS.gold;
  const sizeCls = size === "sm" ? "text-xs px-4 py-2" : "";

  return (
    <a
      href={AI_AGENT_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${sizeCls} ${className}`.trim()}
    >
      <Bot className="w-4 h-4" />
      {label}
      <ArrowUpRight className="w-3.5 h-3.5 opacity-80" />
    </a>
  );
}
